export default "__VITE_ASSET__rm92moSN__"